var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5.688,
    viewBox: "0 0 10 5.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down_arrow",
    "data-name": "down arrow",
    d: "M2.53,12.043a.634.634,0,0,0-.129.189.57.57,0,0,0-.047.234.578.578,0,0,0,.08.3.6.6,0,0,0,.214.215.585.585,0,0,0,.3.08.557.557,0,0,0,.425-.178L7.647,8.517H7.062l4.263,4.365a.571.571,0,0,0,.43.178.585.585,0,0,0,.3-.08.6.6,0,0,0,.214-.215.578.578,0,0,0,.08-.3.566.566,0,0,0-.176-.423L7.8,7.573A.587.587,0,0,0,7.6,7.422a.608.608,0,0,0-.244-.05.616.616,0,0,0-.455.2Z",
    transform: "translate(12.354 13.06) rotate(180)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowOption);
export default __webpack_public_path__ + "static/media/DownArrowOption.8c4df0f80136c254aed33e30ba3c540f.svg";
export { ForwardRef as ReactComponent };